import React from 'react';
import { ButtonImage, ButtonText, ButtonWrapper, TextLink } from './style';
import { MiniLoader } from '../minLoader';

type CommonButtonProps = {
  type?: 'primary' | 'secondary' | 'link' | 'submit' | 'button';
  size?: 'default' | 'small';
  width?: number | string;
  height?: number;
  fontFamily?: string;
  fontSize?: number;
  fontWeight?: number;
  lineHeight?: number;
  borderRadius?: number;
  text: string;
  disabled?: boolean;
  onClick?: (e?: any) => void;
  imgSrc?: string;
  imgPosition?: 'left' | 'right';
  linkDisplay?: string;
  id?: string;
  isLoading?: boolean;
  ref?: React.RefObject<HTMLButtonElement>;
  className?: string;
  margin?: string;
  loaderHeight?: number;
  linkColor?: string;
  backgroundColor?: string;
  role?: string;
};

const CommonButton: React.FC<CommonButtonProps> = (props) => {
  const {
    text,
    imgSrc,
    imgPosition,
    type = 'primary',
    fontFamily,
    fontSize,
    fontWeight,
    lineHeight,
    onClick,
    linkDisplay,
    id,
    isLoading,
    loaderHeight = 15,
    linkColor
  } = props;

  return type === 'link' ? (
    <TextLink
      fontFamily={fontFamily}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      onClick={onClick}
      color={linkColor}
      linkDisplay={linkDisplay}
      id={id}
      {...props}
    >
      {imgSrc && imgPosition === 'left' && (
        <ButtonImage src={imgSrc} imgPosition={imgPosition} alt="Button Icon" />
      )}
      {text}
      {imgSrc && imgPosition === 'right' && (
        <ButtonImage src={imgSrc} imgPosition={imgPosition} alt="Button Icon" />
      )}
    </TextLink>
  ) : (
    <ButtonWrapper {...props} type={type}>
      {imgSrc && imgPosition === 'left' && (
        <ButtonImage src={imgSrc} imgPosition={imgPosition} alt="Button Icon" />
      )}
      {isLoading ? (
        <MiniLoader size={`${loaderHeight}px`} height="auto" color="#fff" />
      ) : (
        <ButtonText margin={imgSrc && '0'}>{text}</ButtonText>
      )}
      {imgSrc && imgPosition === 'right' && (
        <ButtonImage src={imgSrc} imgPosition={imgPosition} alt="Button Icon" />
      )}
    </ButtonWrapper>
  );
};

export default CommonButton;
